import _ from "lodash";
import {
  Component,
} from "react";
import antragApi from "Apis/antrag-api";
import {
  Panel,
  Pill,
  Tooltip,
} from "CommonComponents/bricks";
import {
  ANTRAGSTATUS,
  ANTRAGSTELLERMODUS,
  ASTMODUSKEY,
  getModusFromAntrag,
} from "App/constants";
import store from "CommonState/store";

@antragApi.current
@store("flag_antragstellermodus")
export default class AntragProzessWidget extends Component {
  constructor() {
    super();
    this.state = { data: [], editMode: false, newMode: false };
  }

  render = () => {
    const { currentAntrag, flag_antragstellermodus } = this.props;

    const modusKey = flag_antragstellermodus || (currentAntrag && getModusFromAntrag(currentAntrag));
    const modus = ANTRAGSTELLERMODUS[modusKey] || {};
    const istLehrauftrag = modusKey == ASTMODUSKEY.Lehrauftrag;
    const istTarifvertrag = modusKey == ASTMODUSKEY.Tarif;
    const istVortrag = modusKey == ASTMODUSKEY.Vortrag;

    // TODO Component needs refactoring!

    if (istVortrag) {
      let aktuell = 1;

      if (currentAntrag.a_asid == ANTRAGSTATUS.STATUS_VORTRAG_PRUEFUNG || currentAntrag.a_asid == ANTRAGSTATUS.STATUS_VORTRAG_PRUEFUNG_AUSSENWIRTSCHAFT) {
        aktuell = 3;
      } else if (currentAntrag.a_asid == ANTRAGSTATUS.STATUS_VORTRAG_ABGESCHLOSSEN) {
        aktuell = 4;
      } else if (currentAntrag.a_asid != ANTRAGSTATUS.STATUS_NEU && currentAntrag.a_asid != ANTRAGSTATUS.STATUS_UEBERARBEITEN) {
        aktuell = 2;
      }

      const schritteVortrag = [
        { nr: 1, text: "Daten erfassen", info: "Info zu 1" },
        { nr: 2, text: "Antrag einreichen", info: "Info zu 2" },
        { nr: 3, text: "Antragsprüfung durch die zentrale Vergabestelle", info: "Info zu 3" },
        { nr: 4, text: "Vortrag/Kolloquium ist genehmigt", info: "Info zu 4" },
      ];

      return <Panel header={modus.labelEinstellungsprozess || "Einstellungsprozess"}>
        {_.map(schritteVortrag, (schritt, i) => <Tooltip key={i} overlay={schritt.info}><div style={{ fontSize: "110%" }}><div style={{ fontSize: "120%", marginRight: "0.5em", display: "inline" }}><Pill className='badge-default'>{schritt.nr}</Pill></div>{schritt.nr == aktuell ? <b>{schritt.text}</b> : schritt.text}</div></Tooltip>)}
      </Panel>;
    }

    const schritte = [
      { nr: 1, text: "Daten erfassen und Antrag einreichen", info: "Info zu 1" },
      { nr: 2, text: `Antragsprüfung ${ istTarifvertrag ? "und Bearbeitung " : "" }durch Personaldezernat`, info: "Info zu 2" },
    ];

    const nextPos = () => {
      return _.max(_.map(schritte, x => x.nr)) + 1;
    };

    if (!istLehrauftrag && !istTarifvertrag) {
      // Diesen Schritt nicht bei Lehraufträgen ausgeben)
      schritte.push({ nr: nextPos(), text: `${ modus.labelVertrag } ausdrucken`, info: "Info zu 3" });
    }

    if (istTarifvertrag) {
      schritte.push({ nr: nextPos(), text: `Personaldezernat erstellt ${ modus.labelVertrag }`, info: "Info zu 3" });
    }

    let aktuell = 0;

    const posUnterschrieben = nextPos();
    schritte.push({
      nr: posUnterschrieben,
      text: istTarifvertrag
? "Vertrag unterschreiben und Tätigkeit beginnen"
        : `${ modus.labelVertragUnterschrieben || `Unterschriebenen ${ modus.labelVertrag }` } erhalten und Tätigkeit beginnen`,
      info: `Info zu ${ posUnterschrieben }`,
    });

    if (currentAntrag.a_asid == ANTRAGSTATUS.STATUS_NEU || currentAntrag.a_asid == ANTRAGSTATUS.STATUS_UEBERARBEITEN) {
      aktuell = 1;
    } else if (currentAntrag.a_asid == ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ERSTELLEN
      || currentAntrag.a_asid == ANTRAGSTATUS.STATUS_WERKVERTRAG_ERSTELLEN
      || currentAntrag.a_asid == ANTRAGSTATUS.STATUS_TARIF_VOLLSTAENDIG_GEPRUEFT) {
      aktuell = 3;
    } else if (currentAntrag.a_asid == ANTRAGSTATUS.STATUS_DIENSTVERTRAG_ABGESCHLOSSEN
      || currentAntrag.a_asid == ANTRAGSTATUS.STATUS_WERKVERTRAG_ABGESCHLOSSEN
      || currentAntrag.a_asid == ANTRAGSTATUS.STATUS_DATEN_AN_SVA
      || currentAntrag.a_asid == ANTRAGSTATUS.STATUS_TARIFVERTRAG_ABGESCHLOSSEN
      || currentAntrag.a_asid == ANTRAGSTATUS.STATUS_LEHRAUFTRAG_ABGESCHLOSSEN) {
      aktuell = posUnterschrieben;
    } else {
      aktuell = 2;
    }

    return <Panel header={modus.labelEinstellungsprozess || "Einstellungsprozess"}>
      {_.map(schritte, (schritt, i) => <Tooltip key={i} overlay={schritt.info}><div style={{ fontSize: "110%" }}><div style={{ fontSize: "120%", marginRight: "0.5em", display: "inline" }}><Pill className='badge-default'>{schritt.nr}</Pill></div>{schritt.nr == aktuell ? <b>{schritt.text}</b> : schritt.text}</div></Tooltip>)}
    </Panel>;
  };
}
